import * as React from 'react';
import { be, IndexObject, strapi } from 'models/conent';
import markdownToHtml from 'lib/markdownToHtml'
import Header from 'components/_OldDesign/header';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { translate } from 'utils/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import style from 'styles/Content.module.scss';
import fetch from 'isomorphic-unfetch';
import ModalVideo from 'react-modal-video'
import { NextPageWithLayout } from '@pages/_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import fetchStrapi, { fetchStrapiBySlug } from 'lib/fetchStrapi';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { omitDeep } from 'lodash-omitdeep';

interface Object {
  data: IndexObject[];
}

const IssueDetail: NextPageWithLayout<{issue:any;others:any}> = ({ issue, others }) => {
  const [url, setUrl] = useState(null);
  const [arrays, setArrays] = useState(null);
  const {lang, setLang} = useLocale();
  const [next, setNext] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [playIndex, setPlayIndex] = useState(null)

  useEffect(() => {
    setUrl(window.location.href);
    setLang((localStorage.getItem('lang') ?? 'th') as Lang);
  }, [])

  useEffect(() => {
    const index = others?.contents?.sort((a, b) => a.id > b.id ? 1 : -1).findIndex(obj => obj.id === issue.id);
    const data = others?.contents?.sort((a, b) => a.id > b.id ? 1 : -1);

    if (data) {
      if (index < 1 && others?.contents?.length > 1) {
        setPrevious(null)
        setNext({ id: data[index + 1]?.id, theme: data[index + 1]?.theme })
      } else if (index !== 0 && index !== others?.contents?.length - 1) {
        setNext({ id: data[index + 1]?.id, theme: data[index + 1]?.theme })
        setPrevious({ id: data[index - 1]?.id, theme: data[index - 1]?.theme })
      } else if (index === others?.contents?.length - 1 && others?.contents?.length > 1) {
        setNext(null)
        setPrevious({ id: data[index - 1]?.id, theme: data[index - 1]?.theme })
      }
    }
    const contents = [];
    let first = true;
    const issueData = JSON.parse(JSON.stringify(issue == undefined ? null : issue))
    while (issueData?.blogs?.length > 0) {
      if (first) {
        contents.push(issueData?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1)?.splice(0, 4));
        first = false;
      } else {
        contents.push(issueData?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1)?.splice(0, 5));
        first = true;
      }
    }
    setArrays(contents);
  }, [issue])
  
  return <>
    <Header
      content={ { content: issue?.descriptionTH, title: issue?.theme, image: (be + issue?.image?.url) } }/>
    <div
      className="grid grid-cols-3 align-self-center w-2/3 md:w-1/3 mt-40 sm:mt-36 md:mt-32 xl:mt-24 mx-auto relative">
      <Link href="/issues">
        <div className="bg-dark-blue border-dark-blue border-2 2xl:border-4 text-center text-white py-4 md:py-1">
          <span className="text-3xl md:text-lg lg:text-xl cursor-pointer">Issues</span>
        </div>
      </Link>
      <div className="col-span-2 border-dark-blue border-2 2xl:border-4 text-center py-4 md:py-1">
        <span className="text-3xl md:text-lg lg:text-xl">{ issue?.month }</span>
      </div>
      <div
        className="col-span-3 border-dark-blue border-t-0 border-2 2xl:border-4 2xl:border-t-0 text-center py-5 sm:py-3 2xl:py-2 px-5">
        <span className="text-5xl md:text-4xl 2xl:text-3xl">{ issue?.theme }</span>
      </div>
      { previous ? <Link href={ '/issues/' + previous?.id + '-' + previous?.theme }>
        <FontAwesomeIcon icon={ faChevronLeft }
          className={ `absolute fa-4x text-dark-blue cursor-pointer ${ style.arrowLeft }` }/>
      </Link> : '' }
      { next ? <Link href={ '/issues/' + next?.id + '-' + next?.theme }>
        <FontAwesomeIcon icon={ faChevronRight }
          className={ `absolute fa-4x text-dark-blue cursor-pointer ${ style.arrowRight }` }/>
      </Link> : '' }
    </div>
    <div className="mx-20 mt-20 mb-40">
      { arrays?.map((list, index) => <span key={ index }>
        { index % 2 === 0 ? <>
          <hr className={ `${ index === 0 ? 'md:hidden' : '' } hidden md:block border-dark-blue my-12` }/>
          { list?.map((blog, i) => <span key={ i }>
            { i === 0 ? <div className="grid grid-cols-1 md:grid-cols-5 mb-10 relative">
              <div className="relative md:col-span-3">
                <ModalVideo channel="youtube" autoplay
                  isOpen={ isOpen && playIndex?.index === index && playIndex?.id === i }
                  videoId={ blog?.link }
                  onClose={ () => {
                    setOpen(false);
                    setPlayIndex(null);
                  } }/>
                <img className="w-full object-cover h-96" alt={ blog.title } src={ strapi + blog.image?.url }/>
                { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                  setOpen(true);
                  setPlayIndex({ index: index, id: i });
                } }
                  className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
              </div>
              <div
                className={ `${ index % 4 === 0 ? '' : 'order-last md:order-first' } md:col-span-2 md:px-10 flex flex-col justify-between space-y-5 mt-12 md:mt-0` }>
                { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                  : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                    <div className="text-5xl md:text-3xl lg:text-xl leading-3 cursor-pointer">{ blog.title }</div>
                  </Link> }
                <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                <div className="grid grid-cols-3 align-self-center w-full">
                  <Link href="/issues">
                    <div
                      className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                    </div>
                  </Link>
                  <Link href="/categories">
                    <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div> : '' }
          </span>) }
        </> : '' }
        { index % 2 === 0 && list?.length > 1 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            { list?.map((blog, i) => <span key={ i } className={ i === 0 ? 'hidden' : '' }>
              { i !== 0 ? <div className="grid grid-cols-1 mb-10">
                <div className="relative">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className="w-full object-cover h-96 md:h-56" alt={ blog.title } src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } }
                    className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
                <div className="flex flex-col justify-between space-y-5 mt-7">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl leading-3 cursor-pointer">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                </div>
              </div> : '' }
            </span>) }
          </div>
        </> : '' }
        { index % 2 !== 0 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          { list?.map((blog, i) => <span key={ i }>
            { i === 0 ? <div className="grid grid-cols-1 md:grid-cols-5 mb-10">
              <div className="relative md:col-span-3">
                <ModalVideo channel="youtube" autoplay
                  isOpen={ isOpen && playIndex?.index === index && playIndex?.id === i }
                  videoId={ blog?.link }
                  onClose={ () => {
                    setOpen(false);
                    setPlayIndex(null);
                  } }/>
                <img className="w-full object-cover h-96" alt={ blog.title } src={ strapi + blog.image?.url }/>
                { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                  setOpen(true);
                  setPlayIndex({ index: index, id: i });
                } }
                  className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
              </div>
              <div className="md:col-span-2 md:px-10 flex flex-col justify-between space-y-5 mt-12 md:mt-0">
                { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                  : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                    <div className="text-5xl md:text-3xl lg:text-xl leading-3 cursor-pointer">{ blog.title }</div>
                  </Link> }
                <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                <div className="grid grid-cols-3 align-self-center w-full">
                  <Link href="/issues">
                    <div
                      className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                    </div>
                  </Link>
                  <Link href="/categories">
                    <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div> : '' }
            { i === 1 ? <>
              <hr className="hidden md:block border-dark-blue my-12"/>
              <div className="grid grid-cols-1 md:grid-cols-5 mb-10 relative">
                <div
                  className="order-last md:order-first md:col-span-2 md:px-10 flex flex-col justify-between space-y-5 mt-12 md:mt-0">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl leading-3 cursor-pointer">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                  <div className="grid grid-cols-3 align-self-center w-full">
                    <Link href="/issues">
                      <div
                        className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                        <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                      </div>
                    </Link>
                    <Link href="/categories">
                      <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                        <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="relative md:col-span-3">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className="w-full object-cover h-96" alt={ blog.title } src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } }
                    className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
              </div>
            </> : '' }
          </span>) }
        </> : '' }
        { index % 2 !== 0 && list?.length > 2 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            { list?.map((blog, i) => <span key={ i } className={ i < 2 ? 'hidden' : '' }>
              { i >= 2 ? <div className="grid grid-cols-1 mb-10">
                <div className="relative">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className="w-full object-cover h-96 md:h-56" alt={ blog.title } src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } }
                    className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
                <div className="flex flex-col justify-between space-y-5 mt-7">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl leading-3 cursor-pointer">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                </div>
              </div> : '' }
            </span>) }
          </div>
        </> : '' }
      </span>) }
    </div>
    {/*<Subscribe/>*/ }
  </>
}

export async function getStaticProps({ params, preview = null }) {
  const routeParam = params.id
  let data = await getPreviewIssues(routeParam)
  data.blogs = (data?.blogs ?? []).map((blog) => {
    return omitDeep(blog, ['description', 'descriptionTH', 'categories', 'formats'])
  })
  const issueData = await markdownToHtml(data || '')
  // const res = await fetch(strapi + '/issues');
  let contents = await fetchStrapi('/issues', 3);
  contents = omitDeep(contents, ['blogs', 'formats', 'description', 'descriptionTH', 'formats']);
  return {
    props: {
      issue: {
        ...data,
        issueData,
      },
      others: {
        contents,
      }
    },
  }
}

export async function getStaticPaths() {
  const allPosts = await getAllIssues()  
  return {
    paths: allPosts?.map((issue) => `/issues/${ issue.id }-${ (issue?.theme ?? '').trim() }`) || [],
    fallback: true,
  }
}


async function getPreviewIssues(routeParam): Promise<any> {
  try {
    // const response = await fetch(strapi + '/issues/' + id);
    return await fetchStrapiBySlug('/issues', 'theme', routeParam, 3);
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

async function getAllIssues(): Promise<any> {
  // const response = await fetch(strapi + '/issues');
  return await fetchStrapi('/issues', 1);
}

IssueDetail.getLayout = (page: React.ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default IssueDetail;